import axios from 'axios';
// axios.defaults.headers.common["Authorization"] = authHeaders().Authorization;

const langMap = new Map([
  ['English', 'en'],
  ['Canadian French', 'fr-ca'],
  ['Japanese', 'ja'],
  ['Korean', 'ko'],
  ['Romanian', 'ro'],
  ['Russian', 'ru'],
  ['Simplified Chinese', 'zh-cn'],
  ['Traditional Chinese', 'zh-tw'],
]);

//https://stackoverflow.com/a/55468529/7314900
axios.interceptors.request.use(
  (config) => {
    if (!config.headers.Authorization) {
      const token = window.AUTH_STR || localStorage.getItem('awl_token');

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    // config.headers['x-user-id'] = 'admin';
    const emailId = localStorage.getItem('emailId') || '{}';
    config.headers['email'] = emailId;
    config.headers['x-user-id'] = emailId; //needed when gateway is not used for apis

    config.headers['x-user-locale'] =
      /** @type {import('./types').Window}*/ (window).CHOOSEN_LANGUAGE
        ?.backendHeaderCode || 'en';

    const lang = JSON.parse(
      localStorage.getItem('choosen_language') || '{}',
    )?.value;
    config.headers['accept-language'] = langMap.get(lang);

    return config;
  },
  (error) => Promise.reject(error),
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error(error);
    if (!error.response) {
      // alert('We are facing Network issues.Please come back again');
      return Promise.reject(error);
    }
    if ([502].includes(error.response.status)) {
      return Promise.reject((error.response || {}).data || {});
    }

    if ([401].includes(error.response.status)) {
      //removed 403 as it will be thrown if permisstion not there. No need to refresh on that
      window.logout?.(false); //authContext.handleLogout //false - donot clear oauth server session
      setTimeout(() => {
        localStorage.setItem('logging_out_due_to_auth_error', error.toString());
        localStorage.setItem('return-url', window.location.pathname);
        window.location.href = '/';
      }, 3500);
      throw (error.response || {}).data || {};
    }
    if (
      error.response.status == 404 &&
      error.request.responseURL.includes('wfm/users/userDetails')
    ) {
      localStorage.setItem(
        'login-error',
        error.response.data?.message || 'User Not found',
      );
      return (window.location.href = '/');
    }
    if (error.response.status >= 400) {
      return Promise.reject((error.response || {}).data || {});
    }
    return error;
  },
);

function authHeaders() {
  return {
    Authorization: 'Bearer ' + window.AUTH_STR, // eslint-disable-line
  };
}

export const get = (endpoint) =>
  axios({
    url: process.env.REACT_APP_API_GATEWAY_URL + endpoint,
    method: 'get',
    headers: authHeaders(),
  })
    .then((response) => response)
    .catch((error) => Promise.reject(error.response));

export const post = (endpoint, data) =>
  axios({
    url: process.env.REACT_APP_API_GATEWAY_URL + endpoint,
    method: 'post',
    headers: authHeaders(),
    responseType: 'json',
    data,
  })
    .then((response) => response)
    .catch((error) => Promise.reject(error.response));

export const patch = (endpoint, data) =>
  axios({
    url: process.env.REACT_APP_API_GATEWAY_URL + endpoint,
    method: 'patch',
    headers: authHeaders(),
    responseType: 'json',
    data,
  })
    .then((response) => response)
    .catch((error) => Promise.reject(error.response));

export const remove = (endpoint, data) =>
  axios({
    url: process.env.REACT_APP_API_GATEWAY_URL + endpoint,
    method: 'delete',
    headers: authHeaders(),
    responseType: 'json',
    data,
  })
    .then((response) => response)
    .catch((error) => Promise.reject(error.response));

export default axios;
